import React from "react";
import { connect } from "react-redux";
import { TrendingUp, TrendingDown } from "lucide-react";

//Added lastMonthCompliance,compliance as params by Octopus DevTeam Dec 19,2022
function ComplianceDevicesBox({ value, percentage, lastMonthCompliance, compliance }) {

    const showSpinner = value === 0 ? false : (value === '' ? false : (value === undefined));

    // Logic: Increase (+) in compliance is GOOD (Success). Decrease (-) is BAD (Danger).
    const isIncrease = percentage && percentage.includes("+");
    const isDecrease = percentage && percentage.includes("-");

    return (
        <div className="col-xl-3 col-sm-6 col-12 d-flex">
            <div className="oct_info-box-v2 variant-compliance">
                <div className="oct_info-box-corner-v2"></div>

                <div className="oct_info-box-content-v2">
                    <div className="oct_info-box-text-content-v2">
                        <span className="oct_info-box-title-v2">% Compliance</span>

                        <div data-toggle="tooltip"
                            title={`Percentage of passed rules over total number of validated rules`}>
                            <span className="oct_info-box-number-v2">
                                {showSpinner ? <div className="dot-flashing ml-3 mt-1" /> : `${value}%`}
                            </span>
                        </div>

                        <div className="oct_info-box-footer-v2">
                            {
                                percentage && isIncrease ? (
                                    <div className="d-flex align-items-center" data-toggle="tooltip"
                                        title={`Percentage of passed rules over total number of validated rules has increased by ${percentage}%\nLast Month Compliance was ${lastMonthCompliance}% and now compliance is ${compliance}%`}>
                                        <TrendingUp className="trend-icon text-success" />
                                        <span className="trend-text success">{percentage}%</span>
                                        <span className="trend-label">Since last month</span>
                                    </div>
                                ) : percentage && isDecrease ? (
                                    <div className="d-flex align-items-center" data-toggle="tooltip"
                                        title={`Percentage of passed rules over total number of validated rules has decreased by ${percentage}%\nLast Month Compliance was ${lastMonthCompliance}% and now compliance is ${compliance}%`}>
                                        <TrendingDown className="trend-icon text-danger" />
                                        <span className="trend-text danger">{percentage}%</span>
                                        <span className="trend-label">Since last month</span>
                                    </div>
                                ) : (
                                    <div className="d-flex align-items-center" data-toggle="tooltip"
                                        title={`Percentage of passed rules over total number of validated rules didn't change`}>
                                        {/* <Minus className="trend-icon text-info" /> */}
                                        <span className="trend-text info">{percentage || "0%"}</span>
                                        <span className="trend-label">Since last month</span>
                                    </div>
                                )
                            }
                        </div>
                    </div>

                    <div className="oct_info-box-icon-container-v2">
                        <TrendingUp />
                    </div>
                </div>
            </div>
        </div>
    )

}

export default connect()(ComplianceDevicesBox);
